<template>
  <div class="bg-gray-200 mr-0 overflow-y-auto w-full maincomponent-area">
    <IdentityGrid />
  </div>
</template>

<script>
import IdentityGrid from "./IdentityGrid";

export default {
  name: "identitylist",
  components: { IdentityGrid }
};
</script>
